import React, { useEffect, useMemo, useRef } from "react";
import { ParticleField } from "../particles/ParticleField";

function resolveBackgroundStyle(scene) {
  if (scene.backgroundImage) {
    return undefined;
  }

  return {
    background: `${scene.radialGlow}, ${scene.baseColor}`,
  };
}

export function SceneLayerV3({ theme }) {
  const { scene } = theme;
  const backgroundRef = useRef(null);

  const proceduralStyle = useMemo(() => resolveBackgroundStyle(scene), [scene]);

  useEffect(() => {
    const node = backgroundRef.current;
    if (!node) {
      return undefined;
    }

    let rafId = 0;

    const applyParallax = () => {
      rafId = 0;
      const offset = window.scrollY * scene.parallaxStrength * 0.06;
      node.style.transform = `translate3d(0, ${offset}px, 0)`;
    };

    const onScroll = () => {
      if (rafId) return;
      rafId = requestAnimationFrame(applyParallax);
    };

    applyParallax();
    window.addEventListener("scroll", onScroll, { passive: true });

    return () => {
      if (rafId) {
        cancelAnimationFrame(rafId);
      }
      window.removeEventListener("scroll", onScroll);
      node.style.transform = "translate3d(0, 0, 0)";
    };
  }, [scene.parallaxStrength]);

  return (
    <div className="tl-v3-scene" aria-hidden="true" data-testid="scene-layer-v3">
      <div className="tl-v3-background-wrap">
        {scene.backgroundImage ? (
          <img
            ref={backgroundRef}
            className="tl-v3-background-image"
            src={scene.backgroundImage}
            alt=""
          />
        ) : (
          <div
            ref={backgroundRef}
            className="tl-v3-background-procedural"
            style={proceduralStyle}
          />
        )}
      </div>

      <div className="tl-v3-overlay" style={{ background: scene.overlayTint }} />
      <div
        className="tl-v3-vignette"
        style={{ opacity: scene.vignette }}
      />

      <ParticleField type={scene.particleType} theme={theme} />
    </div>
  );
}
